"use client";

import React from "react";
import { Facebook, Mail, MapPin, Phone, Briefcase } from "lucide-react";
import { Link } from "@/components/common/Link";
import { WvcLogo } from '@/integrations/wordpress/WvcLogo';
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
export default function IndustrialFooter() {
  const services = ["Shoreline Restoration", "Site Preparation", "Septic Systems", "Foundations", "Road Building"];
  const serviceAreas = ["Mercer (54547)", "Manitowish Waters", "Winchester", "Presque Isle", "Boulder Junction", "Oma", "Hurley"];
  const socialLinks = [{
    icon: Facebook,
    href: "https://www.facebook.com/profile.php?id=61590780026193",
    label: "Facebook"
  }];
  return <section id="industrial-footer" className="dark bg-background text-foreground relative pt-16 pb-28 md:pb-12 border-t border-border overflow-hidden">
      {}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent to-background/50 pointer-events-none" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 mb-16">
          
          {}
          <div className="flex flex-col items-start">
            <Link to="/" className="mb-6 inline-block">
              <WvcLogo className="h-10 w-auto" />
            </Link>
            <p className="text-muted-foreground text-sm leading-relaxed mb-6">40 Years of Moving Earth and Digging Dreams. We provide premier residential and commercial excavating and full suite of sand and gravel products for properties across the Northwoods.</p>
            <div className="flex items-center gap-4">
              {socialLinks.map((social, i) => {
              const Icon = social.icon;
              return <Link key={social.label} to={social.href} data-index={i} className="bg-card hover:bg-primary hover:text-primary-foreground text-muted-foreground p-2.5 rounded-md transition-colors duration-300 border border-border hover:border-primary" aria-label={social.label}>
                    <Icon className="size-4" />
                  </Link>;
            })}
            </div>
          </div>

          {}
          <div>
            <h3 className="font-black text-lg uppercase tracking-wider mb-6 text-foreground flex items-center gap-2"><span className="w-2 h-2 bg-primary rounded-sm inline-block"></span>Services</h3>
            <ul className="space-y-3">
              {services.map((service, i) => <li key={service} data-index={i}>
                  <Link to="/SiteEngineeringHubPage" className="text-muted-foreground hover:text-primary transition-colors text-sm font-medium flex items-center group">
                    <span className="w-0 group-hover:w-2 h-[1px] bg-primary mr-0 group-hover:mr-2 transition-all duration-300" />
                    {service}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div>
            <h3 className="font-black text-lg uppercase tracking-wider mb-6 text-foreground flex items-center gap-2">
              <span className="w-2 h-2 bg-primary rounded-sm inline-block" />
              Service Areas
            </h3>
            <ul className="space-y-3">
              {serviceAreas.map((town, i) => <li key={town} data-index={i}>
                  <Link to={i === 0 ? "/MercerPage2" : "/NorthwoodsServiceAreasPage"} className="text-muted-foreground hover:text-primary transition-colors text-sm font-medium flex items-center group">
                    <span className="w-0 group-hover:w-2 h-[1px] bg-primary mr-0 group-hover:mr-2 transition-all duration-300" />
                    {town}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div>
            <h3 className="font-black text-lg uppercase tracking-wider mb-6 text-foreground flex items-center gap-2">
              <span className="w-2 h-2 bg-primary rounded-sm inline-block" />
              Headquarters
            </h3>
            <ul className="space-y-4 mb-6">
              <li className="flex items-start gap-3 text-sm text-muted-foreground">
                <MapPin className="size-5 text-primary shrink-0 mt-0.5" />
                <span>4970 US HWY 51&nbsp;<br />Mercer, Wisconsin, 54547 USA</span>
              </li>
              <li className="flex items-center gap-3 text-sm text-muted-foreground">
                <Phone className="size-5 text-primary shrink-0" />
                <span>715-776-4659</span>
              </li>
              <li className="flex items-center gap-3 text-sm text-muted-foreground">
                <Mail className="size-5 text-primary shrink-0" />
                <span>dirt@joes-excavating.com</span>
              </li>
            </ul>
            
            {}
            <div className="h-32 w-full rounded-md bg-card relative overflow-hidden border border-border group">
              <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1575346/img/northwoods_region_map.png)] bg-cover bg-center transition-transform duration-700 group-hover:scale-110 opacity-60" />
              <div className="absolute inset-0 bg-background/40 group-hover:bg-background/20 transition-colors duration-500" />
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-primary/20 p-3 rounded-lg">
                <div className="bg-primary p-2 rounded-lg">
                  <MapPin className="size-4 text-primary-foreground" />
                </div>
              </div>
            </div>
          </div>

          <div>
            <h3 className="font-black text-lg uppercase tracking-wider mb-6 text-foreground flex items-center gap-2">
              <span className="w-2 h-2 bg-primary rounded-sm inline-block" />
              Careers
            </h3>
            <Link to="/CareersPage" className="flex items-center gap-3 text-sm text-muted-foreground hover:text-primary transition-colors group">
              <div className="bg-card p-2.5 rounded-md border border-border group-hover:border-primary transition-colors">
                <Briefcase className="size-5 text-primary" />
              </div>
              <span className="font-medium">Join Our Team</span>
            </Link>
          </div>
        </div>

        <Separator className="bg-border/50 mb-8" />

        {}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-muted-foreground font-medium">
          <p>&copy; {new Date().getFullYear()} Joe's Excavating. All rights reserved.</p>
          <div className="flex items-center gap-6">
            <Link to="#" className="hover:text-primary transition-colors">Privacy Policy</Link>
            <Link to="#" className="hover:text-primary transition-colors">Terms of Service</Link>
            <Link to="#" className="hover:text-primary transition-colors">Client Portal</Link>
          </div>
        </div>
      </div>

      {}
      <div className="fixed bottom-0 left-0 right-0 p-3 bg-card/95 backdrop-blur-md border-t border-border md:hidden z-50">
        <Button size="lg" asChild className="w-full font-black uppercase tracking-widest text-sm h-12">
          <Link to="/JoesExcavatingLeadCapturePage">
            Get Estimate
          </Link>
        </Button>
      </div>
    </section>;
}